/* eslint-disable no-undef */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { NavLink as RouterLink } from 'react-router-dom';

const { NODE_ENV, REACT_APP_GA_MEASUREMENT_ID: GA_MEASUREMENT_ID } = process.env;

function Page({ title, children, ...rest }) {
  const location = useLocation();
  const [openPaslasmaDialog, setOpenPaslasmaDialog] = React.useState(false);

  useEffect(() => {
    //Paslaşma taleplerini kontrol et eğer paslaşma talebi varsa ve son gösteriminin üzerinden 3 saat geçtiyse popup'ı aç
    var now = Math.floor(Date.now() / 1000) //timestamp olarak tutuyor

    if (sessionStorage.getItem('Pass0') && sessionStorage.getItem('Pass0') !== '0' && sessionStorage.getItem('Pass0LastSeen') + 60 * 60 * 3 < now) {
      setOpenPaslasmaDialog(true);
      sessionStorage.setItem('Pass0LastSeen', now);
    }


    if (NODE_ENV !== 'production') {
      return;
    }

    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname,
        page_name: title
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}





      <Dialog
        open={openPaslasmaDialog}
        onClose={() => setOpenPaslasmaDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Bekleyen paslaşma talepleri"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bekleyen paslaşma talebiniz bulunuyor. Bu uyarıyı 3 saat erteleyebilir veya paslaşma sayfasına gidebilirsiniz. Lütfen en kısa süre içinde bu talepleri onaylayın ya da reddedin.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPaslasmaDialog(false)} color="primary" autoFocus>
            Ertele
          </Button>
          <Button onClick={() => setOpenPaslasmaDialog(false)} component={RouterLink} to={'/PassConfirm'} color="primary" autoFocus>
            Paslaşma Talepleri
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
};

export default Page;
